import { render, staticRenderFns } from "./IrisfmgLogo.vue?vue&type=template&id=722108d9&scoped=true&"
var script = {}
import style0 from "./IrisfmgLogo.vue?vue&type=style&index=0&id=722108d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722108d9",
  null
  
)

export default component.exports